<template>
<div class="detail-body">
      <the-nav-bar :title="$t('global.noticeDetailTitle')" />
      <div class="detail-wrapper">
      <div class="title">{{tigaTitle}}</div>
      <div class="date">{{tigaDate}}</div>
      <div class="content" v-html="contentHtml" ></div> 
      </div>
</div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import getTigaNotice from '@/api/get-tiga-notice.js';
import { mapState } from 'vuex';
import {marked} from 'marked';

export default {
  name: 'notice-bar',
  components: {
    TheNavBar,
  },
  data() {
    return {
      id:0,
      list:[],
    };
  },
  computed: {
    ...mapState({
      navLang: state => state.navLang,
      tigaNotice: state=> state.tigaNotice,
      prefix(){
        if(this.navLang=='zh-cn'){
          return '';
        }
        return this.navLang+'_';
      },
      detail(){
        if(this.list.length>0){
          var temp = this.list.filter(item=>item.id==this.id);
          return temp[0];
        } 
      },
      contentHtml(){
        if(this.list.length>0){
          return marked(this.detail[this.prefix+'content']);
        }
      },
      tigaTitle(){
        if(this.list.length >0){
          return this.detail[this.prefix+'title'];
        }
      },
      tigaDate(){
        if(this.list.length>0){
          return this.detail.created_at;
        }
      },
    }),
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if(!this.tigaNotice){
      getTigaNotice()
        .then(data=>{
          this.list = data.data;
          this.$store.commit('setTigaHome', {
            tigaNotice: this.list,
          });
        });
    }else{
      this.list = this.tigaNotice;
    }
  },
  methods:{

  },
};

</script>

<style lang="stylus" scoped>
.detail-body 
  font-size 3.8vw;
.detail-wrapper
  padding 0 4.8vw;
  .title 
    font-weight: bold;
    margin-bottom: 2vw;
  .date 
    border: 0.27vw solid #eaf1f3;
    border-top-style: hidden;
    border-left-style: hidden;
    border-right-style: hidden;
    margin-bottom: 2vw;
  .content 
    width:100%;
    padding-bottom: 18vw;
>>> img
  width:100% !important;
>>> ul
  padding-inline-start: 6vw;
>>> li 
  list-style: initial;
</style>
